import React, { PropsWithRef } from 'react';
import type { ReactElement } from 'react';
import { getUniqueId } from '@micro-apps/env';
export type Props = {
	id?: string;
	className?: string;
	label: string;
	theme?: 'light' | 'dark';
	defaultChecked?: boolean;
	checked?: boolean;
	onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

export default function Checkbox({
	id = `${getUniqueId()}-checkbox`,
	className = '',
	label,
	theme = 'light',
	defaultChecked,
	checked,
	onChange,
}: PropsWithRef<Props>): ReactElement {
	return (
		<div className={`Checkbox formElement Checkbox--${theme} ${className}`}>
			<input
				id={id}
				className="Checkbox-input formElement-field"
				type="checkbox"
				defaultChecked={defaultChecked}
				checked={checked}
				onChange={onChange}
			/>
			<label
				className="Checkbox-decoration"
				htmlFor={id}
				aria-hidden="true"
				role="presentation"
			></label>
			<label htmlFor={id} className="Checkbox-label">
				{label}
			</label>
		</div>
	);
}
